import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-audit-action-modal',
  templateUrl: './audit-action-modal.component.html',
  styleUrls: ['./audit-action-modal.component.scss']
})
export class AuditActionModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() placeholder: string = 'Ingrese un comentario';
  @Input() required: boolean = false;
  
  commentControl = new FormControl('');

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.required) {
      this.commentControl.setValidators([Validators.required]);
      this.commentControl.updateValueAndValidity();
    }
  }

  confirm() {
    const normalizedComment =
      typeof this.commentControl.value === 'string'
        ? this.commentControl.value.trim()
        : this.commentControl.value;

    this.commentControl.setValue(normalizedComment);

    if (this.commentControl.invalid) {
      this.commentControl.markAsTouched();
      return;
    }
    this.activeModal.close(normalizedComment);
  }
}
